import React from "react";
import { Layout, Tutorial } from "../components";
const TutorialPage = () => {
  return (
    <Layout>
      <Tutorial />
    </Layout>
  );
};

export default TutorialPage;
